import { render, staticRenderFns } from "./MobileReportCard.vue?vue&type=template&id=27568e53"
import script from "./MobileReportCard.vue?vue&type=script&lang=js"
export * from "./MobileReportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports